const rawAssetBaseUrl =
  process.env.NEXT_PUBLIC_ASSET_BASE_URL ||
  process.env.NEXT_PUBLIC_S3_ASSET_BASE_URL ||
  process.env.ASSET_BASE_URL;

const ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:)?\/\//i;
const ABSOLUTE_URL_WITH_SCHEME_REGEX = /^[a-z][a-z0-9+.-]*:\/\//i;

const assetBaseUrl =
  rawAssetBaseUrl && ABSOLUTE_URL_WITH_SCHEME_REGEX.test(rawAssetBaseUrl)
    ? rawAssetBaseUrl.replace(/\/$/, '')
    : undefined;

function isAbsolutePath(path: string) {
  return ABSOLUTE_URL_REGEX.test(path) || path.startsWith('data:') || path.startsWith('blob:');
}

function normalizePath(path: string) {
  if (!path) {
    return path;
  }
  if (path.startsWith('/')) {
    return path;
  }
  return `/${path}`;
}

/**
 * Resolves an asset path to include the configured asset base URL (typically an S3 bucket).
 * Falls back to the provided path when no base URL is configured.
 */
export function resolveAssetPath(path: string) {
  if (!path) {
    return path;
  }

  if (isAbsolutePath(path)) {
    return path;
  }

  const normalizedPath = normalizePath(path);

  if (!assetBaseUrl) {
    return normalizedPath;
  }

  return `${assetBaseUrl}${normalizedPath}`;
}

/**
 * Applies {@link resolveAssetPath} to each URL in a srcset descriptor.
 */
export function resolveAssetSrcSet(srcSet?: string) {
  if (!srcSet) {
    return undefined;
  }

  const parts = srcSet
    .split(',')
    .map((descriptor) => descriptor.trim())
    .filter(Boolean)
    .map((descriptor) => {
      const [url, ...rest] = descriptor.split(/\s+/);
      const resolvedUrl = resolveAssetPath(url);
      if (rest.length === 0) {
        return resolvedUrl;
      }
      return `${resolvedUrl} ${rest.join(' ')}`;
    });

  return parts.join(', ');
}

export function getAssetBaseUrl() {
  return assetBaseUrl;
}
